import { render } from "./AdvisorInfo.vue?vue&type=template&id=66be4086&scoped=true"
import script from "./AdvisorInfo.vue?vue&type=script&lang=js"
export * from "./AdvisorInfo.vue?vue&type=script&lang=js"

import "./AdvisorInfo.vue?vue&type=style&index=0&id=66be4086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66be4086"]])

export default __exports__